<template>
  <div class="row">
    <div class="col-12">
      <form>
        <div class="row my-3">
          <div class="col-12">
            <div class="row">
              <div class="col-3 my-auto">
                <img
                  v-if="product.image_url !== ''"
                  class="img-fluid mh-100"
                  :src="product.image_url"
                />
              </div>
              <div class="col-9">
                <div class="row">
                  <div class="col-7">
                    <div class="row">
                      <div class="col-sm-12 col-md-4">
                        <label class="col-form-label">{{ $t("plum") }} *</label>
                      </div>
                      <div class="col-sm-12 col-md-8">
                        <input
                          type="text"
                          class="form-control"
                          :disabled="
                            this.$route.params.id !== undefined &&
                            this.clone === false
                          "
                          v-model="product.plum"
                          name="product_plum"
                          v-validate="'required'"
                        />
                      </div>
                      <small
                        v-show="errors.has('product_plum')"
                        class="col-12 text-danger"
                      >
                        {{ $t("field_required") }}
                      </small>
                    </div>
                    <div class="row mt-2">
                      <div class="col-sm-12 col-md-4">
                        <label class="col-form-label">{{ $t("ean") }} *</label>
                      </div>
                      <div class="col-sm-12 col-md-8">
                        <input
                          type="text"
                          class="form-control"
                          :disabled="
                            this.$route.params.id !== undefined &&
                            this.clone === false
                          "
                          v-model="product.ean"
                          name="product_ean"
                          v-validate="'required'"
                        />
                      </div>
                      <small
                        v-show="errors.has('product_ean')"
                        class="col-12 text-danger"
                      >
                        {{ $t("field_required") }}
                      </small>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="form-check abc-checkbox form-check-inline py-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'visible-product'"
                        v-model="product.visible"
                      />
                      <label class="form-check-label" :for="'visible-product'">
                        {{ $t("visible") }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row my-3">
          <div class="col-12">
            <div class="row">
              <div class="col-3"></div>
              <div class="col-8">
                <div class="row">
                  <div class="col-12">
                    <label class="col-form-label"
                      >{{ $t("main_image") }} *</label
                    >
                    <small
                      v-show="errors.has('product_image_url')"
                      class="px-2 text-danger"
                    >
                      {{ $t("field_required") }}
                    </small>
                  </div>
                  <div class="col-12">
                    <input
                      type="text"
                      class="form-control"
                      v-model="product.image_url"
                      name="product_image_url"
                      v-validate="'required'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-1 my-auto">
                <div v-show="checkSync()" class="tooltip">
                  <i
                    class="fa"
                    :class="{
                      'fa-check text-success': checkSyncElement('image_url'),
                      'fa-warning text-danger': !checkSyncElement('image_url'),
                    }"
                  ></i>
                  <span class="tooltiptext">{{
                    textElementTooltip("image_url")
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row my-3">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <img
                  v-if="product.packshot_ur !== '' && product.packshot_ur !== null"
                  class="img-fluid mh-100"
                  :src="product.packshot_url"
                />
              </div>
              <div class="col-8">
                <input-file
                  ref="inputPackshotImg"
                  :inputData.sync="product.packshot_url"
                  :prefix="`https://vnfr.cosmogroup.pl/products`"
                  :label="$t('packshot_image')"
                  :urlUploadFile="urlUpdateFile('packshot')"
                  name="product_packshot_url"
                  @loading="updateFileLoading"
                ></input-file>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <img
                  v-if="product.circle_image_url !== '' && product.circle_image_url !== null"
                  class="img-fluid mh-100"
                  :src="product.circle_image_url"
                />
              </div>
              <div class="col-8">
                <input-file
                  ref="inputCircleImg"
                  :inputData.sync="product.circle_image_url"
                  :prefix="`https://vnfr.cosmogroup.pl/circle/prod`"
                  :label="$t('circle_image')"
                  :urlUploadFile="urlUpdateFile('circle')"
                  name="product_circle_image_url"
                  @loading="updateFileLoading"
                ></input-file>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3">
                <img
                  v-if="product.nail_image_url !== '' && product.nail_image_url !== null"
                  class="img-fluid"
                  style="max-height: 130px"
                  :src="`https://vnfr.cosmogroup.pl/nails/images/${product.nail_image_url}`"
                />
              </div>
              <div class="col-8">
                <input-file
                  ref="inputNailImg"
                  :inputData.sync="product.nail_image_url"
                  :prefix="`prod`"
                  :label="$t('nail_image')"
                  :urlUploadFile="urlUpdateFile('nails')"
                  name="product_nail_image_url"
                  @loading="updateFileLoading"
                ></input-file>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-3"></div>
              <div class="col-8">
                <div class="row">
                  <div class="col-12">
                    <label class="col-form-label"
                      >{{ $t("share_url") }} *</label
                    >
                    <small
                      v-show="errors.has('product_share_url')"
                      class="px-2 text-danger"
                    >
                      {{ $t("field_required") }}
                    </small>
                  </div>
                  <div class="col-12">
                    <input
                      type="text"
                      class="form-control"
                      v-model="product.share_url"
                      name="product_share_url"
                      v-validate="'required'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-1 my-auto">
                <div v-show="checkSync()" class="tooltip">
                  <i
                    class="fa"
                    :class="{
                      'fa-check text-success': checkSyncElement('share_url'),
                      'fa-warning text-danger': !checkSyncElement('share_url'),
                    }"
                  ></i>
                  <span class="tooltiptext">{{
                    textElementTooltip("share_url")
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import InputFile from '@/components/InputFile'

export default {
  name: 'VNFRProductFormsMainData',
  components: { InputFile },
  props: {
    product: {
      type: Object,
      required: true
    },
    clone: {
      type: Boolean,
      required: false
    },
    loadingData: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      collectionsList: []
    }
  },
  created() {},
  watch: {
    loadingData( newValue ) {
      if ( newValue === true ) {
        this.$emit( 'loading', true )
      } else {
        this.$emit( 'loading', false )
      }
    }
  },
  methods: {
    urlUpdateFile( type ) {
      return `vnfr/${this.$route.params.env}/products/${type}/file`
    },
    updateFileLoading( loading ) {
      this.$emit( 'loading', loading )
    },
    checkSync() {
      return this.$parent.$parent.checkSync()
    },
    checkSyncElement( name ) {
      return this.$parent.$parent.checkSyncElement( name )
    },
    textElementTooltip( name ) {
      return this.$parent.$parent.textSyncElement( name )
    },
    validationForms() {
      const formValidated = []
      formValidated.push( this.$validator.validateAll() )
      formValidated.push( this.$refs.inputCircleImg.validation() )
      formValidated.push( this.$refs.inputPackshotImg.validation() )
      formValidated.push( this.$refs.inputNailImg.validation() )

      Promise.all( formValidated ).then( value => {
        if ( value.includes( false ) ) {
          return false
        } else {
          return true
        }
      } )
    }
  }
}
</script>
